<script>
import SiteUK from '../site/SiteUK';
import SiteUS from '../site/SiteUS';
import SiteAUS from '../site/SiteAUS';
import SiteCAD from '../site/SiteCAD';

const SITES = {
  'healthywage.co.uk': SiteUK,
  'staging.healthywage.co.uk': SiteUK,
  'development.healthywage.co.uk': SiteUK,

  'healthywage.com': SiteUS,
  'staging.healthywage.com': SiteUS,
  'development.healthywage.com': SiteUS,

  // remove them after the domain expires
  'healthywage.com.au': SiteAUS,
  'staging.healthywage.com.au': SiteAUS,
  'development.healthywage.com.au': SiteAUS,
  // end remove

  'au.healthywage.com': SiteAUS,
  'au-staging.healthywage.com': SiteAUS,
  'au.development.healthywage.com': SiteAUS,

  'ca.healthywage.com': SiteCAD,
  'ca-staging.healthywage.com': SiteCAD,
  'ca.development.healthywage.com': SiteCAD
};

export default {
  name: 'globalized',
  methods: {
    // defined here to be accessed on child 'data' function without errors
    site: function() {
      return createSite();
    }
  }
}

export function createSite() {
  const url = window.location.hostname.replace('www.', '');
  const Site = SITES[url] || SiteUS;

  return new Site();
}
</script>
